import ContentWrapper from "@/components/Core/ContentWrapper";
import styled, { css } from "styled-components";
import CtaRenderer from "@/components/Shared/CtaRenderer";
import mq from "@/utils/mq";
import { render } from "storyblok-rich-text-react-renderer";
import NextLazyImage from "@/components/Core/NextLazyImage";
import { SbImage } from "@/lib/storyblok/storyblok";
import Image from "next/image";

const LargeTextCallToActionContainer = styled.div``;

const OuterContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 3;
`;

const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 572px;
  padding: 162px 0;
  z-index: 3;
`;

const Title = styled.h2<{ $lightMode: boolean }>`
  color: ${({ $lightMode }) => ($lightMode ? "var(--PP-Text-Primary)" : "var(--Light100)")};
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  margin-top: -2px;
  text-wrap: pretty;
  text-align: center;
  z-index: 3;
  ${mq.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)};
`;

const Body = styled.div<{ $lightMode: boolean }>`
  color: ${({ $lightMode }) => ($lightMode ? "#687073" : "#dee0e4")};
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  max-width: 500px;
  justify-self: end;
  text-wrap: pretty;
  margin-bottom: 8px;
  max-width: 500px;
  text-align: center;
  z-index: 3;
  ${mq.mobile(css`
    margin-top: 0px;
    font-size: 14px;
    line-height: 24px;
    max-width: 100%;
    justify-self: start;
  `)};
`;

const CtaButtons = styled.div`
  z-index: 3;
`;

const DarkenOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  backdrop-filter: brightness(0.6);
  z-index: 2;
  pointer-events: none;
`;

const BackgroundImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const ImageGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background:
    linear-gradient(0deg, rgba(31, 33, 33, 0.66) 0%, rgba(31, 33, 33, 0) 62.53%),
    linear-gradient(180deg, rgba(31, 33, 33, 0.3) 0%, rgba(31, 33, 33, 0) 20.29%),
    linear-gradient(0deg, rgba(31, 33, 33, 0.2) 0%, rgba(31, 33, 33, 0.2) 100%);
  z-index: 2;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export default function LargeTextCallToAction({
  title,
  body,
  ctas,
  backgroundColor,
  backgroundImage,
  lightMode,
  addVerticalPaddingTop,
  addVerticalPaddingBottom,
}: {
  title: string;
  body: string;
  ctas: any;
  backgroundColor: string;
  backgroundImage: SbImage;
  lightMode: boolean;
  addVerticalPaddingTop: boolean;
  addVerticalPaddingBottom: boolean;
}) {
  return (
    <LargeTextCallToActionContainer>
      <ContentWrapper
        backgroundColor={backgroundImage && backgroundImage?.filename ? "transparent" : backgroundColor}
        addVerticalPaddingTop={addVerticalPaddingTop}
        addVerticalPaddingBottom={addVerticalPaddingBottom}>
        <OuterContent>
          <InnerContent>
            <Title $lightMode={backgroundImage && backgroundImage?.filename ? false : lightMode}>{title}</Title>
            <Body $lightMode={backgroundImage && backgroundImage?.filename ? false : lightMode}>{render(body)}</Body>
            <CtaButtons>
              <CtaRenderer ctas={ctas} />
            </CtaButtons>
          </InnerContent>
          {backgroundImage && backgroundImage?.filename && (
            <BackgroundImageContainer>
              <ImageContainer>
                <DarkenOverlay />
                <ImageGradient />
                <Image
                  src={backgroundImage.filename}
                  alt={backgroundImage.alt}
                  layout='fullWidth'
                  fill
                  style={{ objectFit: "cover" }}
                />
              </ImageContainer>
            </BackgroundImageContainer>
          )}
        </OuterContent>
      </ContentWrapper>
    </LargeTextCallToActionContainer>
  );
}
